import { Document, Page, View, Text, StyleSheet, Font, PDFViewer } from '@react-pdf/renderer';
import global from 'global';
import prettierNumber from 'utils/prettier-number';
import { transcriptCollateral } from 'utils/transcript';

Font.register({
  family: 'Roboto',
  fonts: [
    {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf',
      fontWeight: 300,
    },
    {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf',
      fontWeight: 700,
    },
  ],
});

const pdfStyles = StyleSheet.create({
  page: {
    fontFamily: 'Roboto',
    padding: '10px',
    paddingLeft: '30px',
    paddingRight: '30px',
  },
  section: {
    marginBottom: '10px',
    marginTop: '10px',
  },
  heading: {
    fontSize: '20px',
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: '10px',
  },
  text: {
    fontSize: '12px',
  },
  table: {
    backgroundColor: '#fff',
  },
  tr: {
    display: 'flex',
    flexDirection: 'row',
  },
  td: {
    border: '1px solid #000',
    width: '100%',
    padding: '5px 10px',
    fontSize: '12px',
  },
  result: {
    fontSize: '15px',
    fontWeight: 900,
  },
  bottom: {
    margin: '10px 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  gpt_text: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#000',
  },
});

export const PdfCollateral = ({
  contextApplication,
}: {
  contextApplication: global.contextApplicationCollateral;
}) => {
  return (
    <PDFViewer style={{ width: '100%', height: 'calc(100vh - 150px)' }}>
      <Document>
        {contextApplication.data?.scoring_gold_log && (
          <Page style={pdfStyles.page}>
            <View style={pdfStyles.heading}>
              <Text>Результат скоринга</Text>
            </View>
            <View style={pdfStyles.section}>
              <Text style={pdfStyles.text}>
                Скоринг проведён экспертом: {contextApplication.data?.created_by.first_name ?? ''}{' '}
                {contextApplication.data?.created_by.last_name ?? ''} (
                {contextApplication.data?.created_by.email ?? ''}){' '}
              </Text>
              <Text style={pdfStyles.text}>
                Дата/время: {new Date(contextApplication.data?.created_at ?? '').toLocaleString()}
              </Text>
              <Text style={pdfStyles.text}>Заявка №{contextApplication.data?.id}</Text>
              <View style={pdfStyles.table}>
                <View style={pdfStyles.tr}>
                  <View style={pdfStyles.td}>
                    <Text>ИНН</Text>
                  </View>
                  <View style={pdfStyles.td}>
                    <Text>{contextApplication.data?.inn}</Text>
                  </View>
                </View>

                <View style={pdfStyles.tr}>
                  <View style={pdfStyles.td}>
                    <Text>Запрашиваемая сумма</Text>
                  </View>
                  <View style={pdfStyles.td}>
                    <Text>
                      {prettierNumber(contextApplication.data?.requested_amount ?? 0)}{' '}
                      {transcriptCollateral.currency.getValueFromKey(
                        contextApplication.data?.currency ?? '',
                      )}
                    </Text>
                  </View>
                </View>

                <View style={pdfStyles.tr}>
                  <View style={pdfStyles.td}>
                    <Text>Длительность</Text>
                  </View>
                  <View style={pdfStyles.td}>
                    <Text>{prettierNumber(contextApplication.data?.duration)} мес.</Text>
                  </View>
                </View>

                <View style={pdfStyles.tr}>
                  <View style={pdfStyles.td}>
                    <Text>Процентная ставка</Text>
                  </View>
                  <View style={pdfStyles.td}>
                    <Text>{prettierNumber(contextApplication.data?.int_rate)}%</Text>
                  </View>
                </View>

                <View style={pdfStyles.tr}>
                  <View style={pdfStyles.td}>
                    <Text>Возраст</Text>
                  </View>
                  <View style={pdfStyles.td}>
                    <Text>{contextApplication.data?.scoring_gold_log?.age}</Text>
                  </View>
                </View>

                <View style={pdfStyles.tr}>
                  <View style={pdfStyles.td}>
                    <Text>Пол</Text>
                  </View>
                  <View style={pdfStyles.td}>
                    <Text>
                      {transcriptCollateral.gender.getValueFromKey(
                        contextApplication.data?.scoring_gold_log?.gender,
                      )}
                    </Text>
                  </View>
                </View>

                <View style={pdfStyles.tr}>
                  <View style={pdfStyles.td}>
                    <Text>Семейное положение</Text>
                  </View>
                  <View style={pdfStyles.td}>
                    <Text>
                      {transcriptCollateral.maritalStatus.getValueFromKey(
                        contextApplication.data?.scoring_gold_log?.marital_status,
                      )}
                    </Text>
                  </View>
                </View>

                <View style={pdfStyles.tr}>
                  <View style={pdfStyles.td}>
                    <Text>Кол-во иждивенцев</Text>
                  </View>
                  <View style={pdfStyles.td}>
                    <Text>{contextApplication.data?.scoring_gold_log?.dependants}</Text>
                  </View>
                </View>

                <View style={pdfStyles.tr}>
                  <View style={pdfStyles.td}>
                    <Text>Образование</Text>
                  </View>
                  <View style={pdfStyles.td}>
                    <Text>
                      {transcriptCollateral.education.getValueFromKey(
                        contextApplication.data.scoring_gold_log.education,
                      )}
                    </Text>
                  </View>
                </View>

                <View style={pdfStyles.tr}>
                  <View style={pdfStyles.td}>
                    <Text>Месячный доход клиента</Text>
                  </View>
                  <View style={pdfStyles.td}>
                    <Text>
                      {prettierNumber(
                        contextApplication.data?.scoring_gold_log?.monthly_income ?? 0,
                      )}
                    </Text>
                  </View>
                </View>

                <View style={pdfStyles.tr}>
                  <View style={pdfStyles.td}>
                    <Text>Кол-во предыдущих кредитов</Text>
                  </View>
                  <View style={pdfStyles.td}>
                    <Text>
                      {prettierNumber(
                        contextApplication.data?.scoring_gold_log?.credit_history_count ?? 0,
                      )}
                    </Text>
                  </View>
                </View>

                <View style={pdfStyles.tr}>
                  <View style={pdfStyles.td}>
                    <Text>Место работы клиента</Text>
                  </View>
                  <View style={pdfStyles.td}>
                    <Text>
                      {transcriptCollateral.workPlace.getValueFromKey(
                        contextApplication.data?.scoring_gold_log?.work_place,
                      )}
                    </Text>
                  </View>
                </View>

                <View style={pdfStyles.tr}>
                  <View style={pdfStyles.td}>
                    <Text>Опыт работы (в месяцах)</Text>
                  </View>
                  <View style={pdfStyles.td}>
                    <Text>{contextApplication.data?.scoring_gold_log?.work_experience}</Text>
                  </View>
                </View>

                <View style={pdfStyles.tr}>
                  <View style={pdfStyles.td}>
                    <Text>Город/Район</Text>
                  </View>
                  <View style={pdfStyles.td}>
                    <Text>
                      {transcriptCollateral.district.getValueFromKey(
                        contextApplication?.data?.scoring_gold_log?.district,
                      )}
                    </Text>
                  </View>
                </View>

                <View style={pdfStyles.tr}>
                  <View style={pdfStyles.td}>
                    <Text>Тип клиента</Text>
                  </View>
                  <View style={pdfStyles.td}>
                    <Text>
                      {transcriptCollateral.clientType.getValueFromKey(
                        contextApplication.data?.scoring_gold_log?.client_type,
                      )}
                    </Text>
                  </View>
                </View>
              </View>
              <View style={pdfStyles.bottom}>
                <Text style={pdfStyles.result}>
                  Результат:{' '}
                  {contextApplication.data?.scoring_gold_log.is_approved ? 'Одобрено' : 'Отказано'}{' '}
                  {Math.round(contextApplication.data?.scoring_gold_log?.prediction)}%
                </Text>
                <Text style={pdfStyles.result}>
                  Порог: {Number(contextApplication.data?.scoring_gold_log?.threshold) * 100}%
                </Text>
              </View>
            </View>
          </Page>
        )}
      </Document>
    </PDFViewer>
  );
};
